import * as React from 'react';
import { Collapse, List, ListItem, ListItemIcon } from '@mui/material';
import {
  SectionContainer,
  StyledListItemButton,
  StyledListItemIcon,
  StyledListItemText,
  SubMenuContainer,
  SubMenuListItemText,
} from './styles';
import { ArrowDropDownOutlined, ArrowDropUpOutlined } from '@mui/icons-material';
import NavTooltip from './NavTooltip';

interface ListButtonsProps {
  buttons: {
    icon: JSX.Element;
    text: string;
    onClick?: () => void;
    isActive?: boolean;
    showButtonsCollapse?: boolean;
    collapsedButtons?: {
      icon: JSX.Element;
      text: string;
      onClick?: () => void;
      isActive?: boolean;
    }[];
  }[];
  isOpen: boolean;
  /** Compact rows + no list padding — for the drilled-in Team Notes folder panel
   * where many folders need to fit without running out of vertical space. */
  dense?: boolean;
}

const ListButtons: React.FC<ListButtonsProps> = ({ buttons, isOpen, dense = false }) => {
  return (
    <List disablePadding={dense} sx={dense ? { pt: 2 } : undefined}>
      {buttons.map((button, index) => (
        <SectionContainer
          key={index}
          isOpen={isOpen}
          isExpanded={!!button.showButtonsCollapse && !!button.collapsedButtons?.length}
        >
          <ListItem sx={dense ? { py: 0 } : undefined}>
            <NavTooltip label={button.text} isOpen={isOpen}>
              <StyledListItemButton
                onClick={button.onClick}
                disableRipple
                isActive={!!button.isActive}
                isOpen={isOpen}
                dense={dense}
              >
                <StyledListItemIcon isOpen={isOpen}>{button.icon}</StyledListItemIcon>
                <StyledListItemText primary={button.text} />
                {button.collapsedButtons && (
                  <ListItemIcon sx={{ minWidth: 'auto' }}>
                    {button.showButtonsCollapse ? <ArrowDropUpOutlined /> : <ArrowDropDownOutlined />}
                  </ListItemIcon>
                )}
              </StyledListItemButton>
            </NavTooltip>
          </ListItem>
          {button.collapsedButtons && button.collapsedButtons.length > 0 && (
            <Collapse in={button.showButtonsCollapse} timeout="auto" unmountOnExit>
              <SubMenuContainer isOpen={isOpen}>
                {button.collapsedButtons.map((collapsedButton, idx) => (
                  <ListItem key={idx}>
                    <NavTooltip label={collapsedButton.text} isOpen={isOpen}>
                      <StyledListItemButton
                        onClick={collapsedButton.onClick}
                        disableRipple
                        isActive={!!collapsedButton.isActive}
                        isCollapsed
                        isOpen={isOpen}
                      >
                        <StyledListItemIcon isOpen={isOpen}>{collapsedButton.icon}</StyledListItemIcon>
                        <SubMenuListItemText primary={collapsedButton.text} />
                      </StyledListItemButton>
                    </NavTooltip>
                  </ListItem>
                ))}
              </SubMenuContainer>
            </Collapse>
          )}
        </SectionContainer>
      ))}
    </List>
  );
};

export default ListButtons;
